import { routePaths } from "@/shared/config/routePaths";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const OrganizationDetailsPage = lazy(() => import('./OrganizationDetailsPage').then(m => ({ default: m.OrganizationDetailsPage })));
const EntitlementsPage = lazy(() => import('./EntitlementsPage').then(m => ({ default: m.EntitlementsPage })));

export const organizationsRouter: RouteObject = {
    path: routePaths.organizations.base,
    children: [
        {
            path: routePaths.organizations.details.relative,
            element: <OrganizationDetailsPage />
        },
        {
            path: routePaths.organizations.entitlements.relative,
            element: <EntitlementsPage />
        }
    ]
};
